export const getTranslatedText = (translatedTextContent , key ,defaultKey) => {
    const text = translatedTextContent?.length > 0
                            ? translatedTextContent?.filter(
                                (item) =>
                                  item.pageKey === key,
                              )[0]?.keyValue
                              ? translatedTextContent?.filter(
                                  (item) =>
                                    item.pageKey ===
                                    key,
                                )[0]?.keyValue
                              : defaultKey
                  : defaultKey;

    return text;
}